import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import CustomFormsService from 'cio/services/custom-forms';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import { isEmpty } from '@ember/utils';

export default class IntegrationsFormsGeneralSettings extends Route {
  @service analytics!: AnalyticsService;
  @service customForms!: CustomFormsService;
  @service facebookLeadAds!: FacebookLeadAdsService;

  redirect() {
    // when there are no forms to display anywhere, go to the correct blank slate page URL:
    if (isEmpty(this.customForms.forms) && isEmpty(this.facebookLeadAds.connectedNowOrBeforeForms)) {
      return this.router.transitionTo('integrations.forms.general.index');
    }

    return;
  }

  activate() {
    super.activate();

    this.analytics.track('forms', 'settings_viewed');
  }
}
